var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneFilled = function SvgPhoneFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3070_26919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.722 11.683a15.06 15.06 0 0 0 6.59 6.585l2.2-2.205c.275-.275.67-.355 1.015-.245 1.12.37 2.325.57 3.57.57.555 0 1 .445 1 1v3.5c0 .555-.445 1-1 1-9.39 0-17-7.61-17-17a1 1 0 0 1 1-1h3.5c.555 0 1 .445 1 1 0 1.245.2 2.45.57 3.57.11.345.03.74-.245 1.015l-2.2 2.21Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3070_26919"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.791,
    width: 24,
    height: 24,
    rx: 5,
    fill: "#fff"
  })))));
};
export default SvgPhoneFilled;